import { Component, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PermissionService } from 'src/app/auth/permission.service';
import { SyncModel } from './model/sync.model';
import { AreaService } from '../../system/area/area.service';
import { SyncErrorService } from './sync-error.service';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { title } from 'process';

@Component({
  selector: 'app-sync-error',
  standalone: false,
  templateUrl: './sync-error.component.html',
  styleUrl: './sync-error.component.scss'
})
export class SyncErrorComponent {

  syncList: SyncModel[] = [];
  
    showSearch: boolean = false;
    isLoading = true;
    filter: FilterListItemModel[] = [
      {
        title: "Module",
        column: "table_name",
      },
      {
        title: "Shop Name",
        column: "shop_name",
      },
        {     
      title: "Action",
      column: "crud_action",
      },
        {
      title: "Sync Status",
      column: "sync_status",    
      }
  
    ];
    displayedColumns = [ 'table_name', 'shop_name',  'crud_action','sync_status',];
    pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
    menuOption: FloatingMenuOption = {
      add: true,
      search: false,
      export: true,
      more: true
    }
  
    isHandset: boolean = false;
    searchColumFilter: SearchParam = {};
    columnSortData: SearchSort[] = [];
    selectedItem?: SyncModel;
    showSummaryPanel: boolean = false;
    selection = new SelectionModel<SyncModel>(true, []);
    dataSource = new MatTableDataSource(this.syncList);
    IsDownloading: boolean = false;
    permission: any;
    shopListData: any = [];
  
    constructor(private breakpointObserver: BreakpointObserver,
      private syncService: SyncErrorService,
      public dialog: MatDialog,
      private snackBarService: SnackBarService,
      private permissionService: PermissionService,
      private router: Router, private stateManagerService: StateManagerService,
      private shopinfoService: ShopinfoService
    ) {
  
      this.syncList = [];
      this.permission = permissionService.getPagePermission("sync-error");
      console.log(this.permission);
  
    }
    /**
      * initilaize the device model
      */
    ngOnInit(): void {
      this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isHandset = true;
        } else {
          this.isHandset = false;
        }
      });
      this.isLoading = false; // Set to true on page load
      //this.loadData();
       
    }
    /** 
     * Set the datasource
     */
    setDataSource(syncList: SyncModel[]) {
      this.dataSource = new MatTableDataSource(syncList);
      this.dataSource.sort = this.sort;
    }
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
    ngAfterViewInit(): void {
  
      this.loadPreviousState();
      // this.loadData();
    }
  
    /**
     * loads the previous state if exists
     */
    loadPreviousState(): void {
  
      var previousState = this.stateManagerService.getState(this.constructor.name);
  
      if (previousState !== undefined && this.searchFilter != undefined) {
  
        if (previousState.state.search.filters.scope) {
          this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
          this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
        }
  
        if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
          this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
        }
  
        this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
        this.searchFilter.setSearchFilter(this.searchColumFilter, true);
  
      } else {
        this.setSortColumn('table_name', 'asc');
        this.loadData();
      }
  
    }
    /**
     * Sets the sort column
     * @param column 
     * @param direction 
     */
    setSortColumn(column: string, direction: SortDirection): void {
      this.columnSortData.length = 0;
      this.columnSortData.push({ column: column, order: direction });
      this.sort.sort({
        id: column,
        start: direction,
        disableClear: false,
      });
  
      // this.sort.active=column;
      // this.sort.direction=direction;
  
  
    }
  
  
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.syncList.length;
      return numSelected === numRows;
    }
  
    toggleAllRows() {
      if (this.isAllSelected()) {
        this.selection.clear();
        return;
      }
  
      this.selection.select(...this.syncList);
    }
  
    /**
     * Create sort order
     * @returns sort criteria
     */
    getSort(): SearchSort[] {
      return this.columnSortData;
    }
  
    /**
       * Builds the request data to be send to API
       * @returns Request Data
       */
    buildRequestData(): RequestData {
      let searchParam = this.getSearchParam();
      let requestData: RequestData = {
        search: {
          filters: {
            simpleSearch: searchParam.freeSearch,
            advSearch: [
              ...(searchParam.advSearch || []),
              // ...this.getDefaultSearchParams(searchParam.advSearch),
            ],
            scope: {
              limit: this.pagingData.pageSize,
              offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
            }
          },
          sort: this.getSort(),
        }
      };
  
      return requestData;
    }
  
    /**
     * Check and apply default filter for is_system = 0.
     **/
    getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
      var defFilter: any = [];
      if (
        searchFilter == undefined ||
        !searchFilter.some((sf: any) => sf.column == "is_system")
      ) {
        defFilter.push({
          column: "is_system",
          operator: "=",
          value: "0",
        });
      }
      return defFilter;
    }
  
    /**
      * Set the column filter and reaload the daaa
      * @param columFilter 
      */
  
    onFilterApplied(columFilter: any): void {
      this.searchColumFilter = columFilter;
      this.loadData();
  
    }
  
    /**
      * On delete menu item selected
      * Confirm the action and call the api to update
      */
    // onDelete(areaInfo: syncModel): void {
    //   const areaId = areaInfo.id;
    //   const message = `Are you sure, you want to delete ` + (areaInfo.name + "?");
    //   const dialogData = new ConfirmDialogModel("Confirm Deletion", message);
  
    //   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //     maxWidth: "400px",
    //     data: dialogData
    //   });
  
    //   dialogRef.afterClosed().subscribe(dialogResult => {
    //     console.log(dialogResult);
    //     if (dialogResult) {
    //       this.areaService.delete(areaInfo).subscribe({
    //         next: (response) => {
    //           if (response.status == 'SUCCESS') {
    //             // handle success
    //             let snckBarData: SnackBarData = {
    //               type: 'success',
    //               title: 'Saved',
    //               message: 'The record for ' + areaInfo.name + " has been deleted succesfully."
    //             }
    //             this.snackBarService.openSnackBar(snckBarData);
    //             this.loadData();
    //           } else {
    //             let snackBarData: SnackBarData = {
    //               message: response.message,
    //               title: 'Failed!!!',
    //               type: 'error'
    //             }
    //             this.snackBarService.openSnackBar(snackBarData);
    //           }
    //         },
    //         error: (error) => {
    //           let snackBarData: SnackBarData = {
    //             message: 'Failed to update. Connection to the server failed',
    //             title: 'Failed!!!',
    //             type: 'error'
    //           }
    //           this.snackBarService.openSnackBar(snackBarData);
    //         }
    //       });
    //     }
    //   });
    // }
  
    /**
     * loads the data based on the conditions
     */
    loadData(): void {
      this.isLoading = true;
      let requestData = this.buildRequestData();
      let response = this.syncService.getSyncErrorList(requestData).subscribe(response => {
        if (response.status == 'SUCCESS') {
          this.setDataSource(response.data.sync_errors);
          this.pagingData.length = response.data.total_count;
          if (this.pagingData.length == 0) {
            let snackBarData: SnackBarData = {
              message: 'No data found. Please remove or change the filter if any.',
              title: 'No Data!!!',
              type: 'warn'
            }
            this.snackBarService.openSnackBar(snackBarData);
            this.selectedItem = undefined;
          } else {
            this.onRowSelected(this.syncList[0])
            this.stateManagerService.setState(this.constructor.name, requestData);
          }
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
        this.isLoading = false;
      });
  
    }
  
    /**
    * On areainfo selected
    * @param syncInfo      
    */
    onRowSelected(syncInfo: SyncModel): void {
      this.selectedItem = syncInfo;
      this.showSummaryPanel = true;
    }
  
    /**
      *  Set the sort param and relead the data
      * @param $event sort data
      * {"active": "email","direction": "asc"}
      *   
      */
    sortData($event: any): void {
      var sd = this.sort;
      this.columnSortData.length = 0;
      this.columnSortData.push({ column: sd.active, order: sd.direction });
      this.loadData();
    }
    /**
  * Creates the column filter conditions based on search criteria
  * @returns Filter condions for columns
  */
    getSearchParam(): SearchParam {
  
      return this.searchColumFilter;
    }
  
    /**
   * On edit the item
   * Show the edit dialog
   */
    // onEdit(syncInfo: SyncModel): void {
  
    //   this.router.navigate(['system/region-edit', syncInfo.id]);
    // }
  
  
    /**
     * 
     * @param event 
     * When page size is changed update paging data
     */
    onePageEvent(event: any): void {
  
      this.pagingData.pageIndex = event.pageIndex;
      this.pagingData.pageSize = event.pageSize;
  
      this.loadData();
  
    }
  
    /**
     * On Add clicked
     * Show the dialog to enter new area
     */
    
  
    // exportClicked() {
    //   this.isLoading = true;
    //   let requestData = this.buildRequestData();
    //   this.IsDownloading = true;
    //   this.areaService.downloadExcel(requestData)
    //     .subscribe({
    //       next: blob => {
    //         // Download logic
    //         this.IsDownloading = false;
    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.download = 'region_list.csv'; // Adjust filename if needed
    //         link.click();
    //         window.URL.revokeObjectURL(url);
    //         this.isLoading = false;
  
  
    //       },
    //       error: error => {
    //         // Handle errors
    //         this.IsDownloading = false;
    //         let snackBarData: SnackBarData = {
    //           message: 'Failed to update. Connection to the server failed',
    //           title: 'Failed!!!',
    //           type: 'error'
    //         }
    //         this.snackBarService.openSnackBar(snackBarData);
    //         this.isLoading = false;
    //         // Display user-friendly error message to the user
    //       }
    //     }
    //     );
    // }

    

    /**
     * Returns the shop name for a given shop_id
     */
    getShopName(shopId: string | number): string {
      const idNum = typeof shopId === 'string' ? parseInt(shopId, 10) : shopId;
      const shop = this.shopListData.find((s: any) => s.item.id === idNum);
      return shop ? shop.item.name : String(shopId);
    }


    /**
 * Opens a dialog to show the sync error message
 * @param syncInfo The selected sync error record
 */
// showErrorMessage(syncInfo: any): void {
//   // Use 'error_msg' from your API object. 
//   // If the field name is different (e.g., 'message'), update it here.
//   const errorMessage = syncInfo.error_msg || 'No detailed error message available.';
  
//   const dialogData = new ConfirmDialogModel(
//     "Sync Error Details", // Dialog Title
//     errorMessage         // Dialog Message
//   );

//   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    
//     minWidth: "300px",
//     data: dialogData
//   });

//   // Optional: Do something when the dialog closes
//   dialogRef.afterClosed().subscribe(dialogResult => {
//     console.log('Error dialog closed');
//   });
// }


@ViewChild('errorDialog') errorDialog!: TemplateRef<any>;
selectedErrorMsg: string = '';

showErrorMessage(syncInfo: any): void {
  // Extract error message from the data object
  this.selectedErrorMsg = syncInfo.error_msg || 'No detailed error message available.';

  // Open the dialog using the template above
  this.dialog.open(this.errorDialog, {
    minWidth: '300px',
    panelClass: 'custom-error-dialog' // For custom styling
  });
}
}
